'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

var _take3 = require('lodash/take');

var _take4 = _interopRequireDefault(_take3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _update = require('react/lib/update');

var _update2 = _interopRequireDefault(_update);

var _index = require('components/index');

var _strings = require('helpers/strings');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _cloudConfig = require('../cloud-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./CloudBrowser.scss');

var CloudBrowser = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(CloudBrowser, _Component);

  function CloudBrowser() {
    var _ref;

    (0, _classCallCheck3.default)(this, CloudBrowser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudBrowser.__proto__ || (0, _getPrototypeOf2.default)(CloudBrowser)).call.apply(_ref, [this].concat(args)));

    _this.state = { selectedFiles: {} };
    return _this;
  }

  (0, _createClass3.default)(CloudBrowser, [{
    key: 'onSelect',
    value: function onSelect(item, breadcrumb) {
      if (item && !this.isAcceptableFile(item)) {
        return false;
      }

      var onSelect = this.props.onSelect;

      if (item && item.__type === 'file') {
        var newState = void 0;
        if (this.state.selectedFiles[item.__id]) {
          var selectedFiles = (0, _extends3.default)({}, this.state.selectedFiles);
          delete selectedFiles[item.__id];
          newState = (0, _extends3.default)({}, this.state, { selectedFiles: selectedFiles });
        } else {
          newState = (0, _update2.default)(this.state, { selectedFiles: (0, _defineProperty3.default)({}, item.__id, { $set: item }) });
        }

        this.setState(newState);
      }

      onSelect(item, breadcrumb);
    }
  }, {
    key: 'getBreadcrums',
    value: function getBreadcrums() {
      var pathCollection = this.props.pathCollection;

      var breadcrumbs = [];
      var pathFull = '';
      var lastBreadcrumb = {};

      pathCollection.map(function (pathItem) {
        if (pathItem) {
          pathFull += '/' + pathItem.name;
          var bcCollection = [].concat((0, _toConsumableArray3.default)(pathCollection));

          lastBreadcrumb = {
            id: pathItem.id,
            name: pathItem.name,
            path: pathFull,
            pathCollection: (0, _take4.default)(bcCollection, breadcrumbs.length + 1)
          };
          breadcrumbs.push(lastBreadcrumb);
        }
      });

      return breadcrumbs;
    }
  }, {
    key: 'unselect',
    value: function unselect() {
      this.setState({ selectedFiles: {} });
    }
  }, {
    key: 'add',
    value: function add() {
      var onResult = this.props.onResult;
      var selectedFiles = this.state.selectedFiles;

      onResult(selectedFiles);
    }
  }, {
    key: 'isAcceptableFile',
    value: function isAcceptableFile(item) {
      var fileTypes = this.props.fileTypes;

      return item.__type !== 'file' || (0, _isEmpty4.default)(fileTypes) || fileTypes.indexOf(item.__ext) !== -1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          error = _props.error,
          t = _props.t,
          onError = _props.onError,
          onCancel = _props.onCancel,
          processing = _props.processing,
          service = _props.service;
      var selectedFiles = this.state.selectedFiles;

      var selectedCount = (0, _keys2.default)(selectedFiles).length;
      var breadcrumbs = this.getBreadcrums();
      var serviceImg = _cloudConfig.assetsIcons[service];
      var errorText = t('An error has occurred with {{service}}. Please, try to "Reconnect"', { service: (0, _strings.capitalize)(service) });
      var fileItemClass = function fileItemClass(item) {
        var _classNames;

        return (0, _classnames2.default)(styles.item, styles[item.__type], (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.selected, selectedFiles[item.__id]), (0, _defineProperty3.default)(_classNames, styles.inactive, !_this2.isAcceptableFile(item)), _classNames));
      };

      return _react2.default.createElement(
        'div',
        { className: styles.cloudBrowser },
        _react2.default.createElement(
          'div',
          { className: styles.breadcrumbsContainer },
          _react2.default.createElement(
            'ul',
            { className: styles.breadcrumbs },
            breadcrumbs.map(function (bc, index) {
              return _react2.default.createElement(
                'li',
                { key: bc.id, onClick: function onClick() {
                    return _this2.onSelect(null, bc);
                  } },
                !index && _react2.default.createElement('img', { className: styles.serviceImg, src: serviceImg, alt: '' }),
                ' ',
                bc.name
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.files },
          error && _react2.default.createElement(
            'div',
            { className: 'error text-center' },
            _react2.default.createElement(
              'div',
              null,
              errorText
            ),
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary small squared margin-top-10', onClick: onError },
              t('Reconnect')
            )
          ),
          !!items && !error && items.map(function (item) {
            return _react2.default.createElement(
              'div',
              {
                key: item.__id,
                className: fileItemClass(item),
                onClick: function onClick() {
                  return _this2.onSelect(item);
                }
              },
              item.__name
            );
          }),
          !error && !items && _react2.default.createElement(_index.Loader, { mask: true })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.footer },
          _react2.default.createElement(
            'span',
            { className: styles.selectedHint },
            !!selectedCount && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { className: 'vertical-middle' },
                t('Selected'),
                ': ',
                selectedCount
              ),
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-close', styles.unselectButton), onClick: this.unselect, title: t('Clear selection') })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: styles.actions },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-clear small squared margin-left-10', onClick: onCancel },
              t('Cancel')
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary small squared margin-left-10 pos-rel',
                onClick: this.add,
                disabled: !selectedCount || processing
              },
              t('Add'),
              processing && _react2.default.createElement(_index.Loader, { mask: true, small: true })
            )
          )
        )
      );
    }
  }]);
  return CloudBrowser;
}(_ClientSideComponent2.default), _class3.propTypes = {
  error: _propTypes2.default.string,
  fileTypes: _propTypes2.default.array,
  items: _propTypes2.default.array,
  onCancel: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onResult: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  pathCollection: _propTypes2.default.array,
  processing: _propTypes2.default.bool,
  service: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onCancel: function onCancel() {},
  onError: function onError() {},
  onResult: function onResult() {},
  onSelect: function onSelect() {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'unselect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'unselect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'add', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'add'), _class2.prototype)), _class2)) || _class);
exports.default = CloudBrowser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/CloudBrowser/CloudBrowser.js
// module id = 1968
// module chunks = 1